import PropTypes from "prop-types";
import { idPropType } from "./id-prop-type";

export const carouselPropType = PropTypes.shape({
  id: idPropType,
  products: PropTypes.arrayOf(PropTypes.shape), // let's avoid too many dependencies here. (namely, keep it an object instead of arrayOf(productPropType))
  requestId: idPropType,
});
